import { useEffect } from 'react'
import axios from 'axios'
import { API, isTestUrl } from '../utils'
import { UserAuthorizationService } from '../service'

export function useCheckLogin() {
  useEffect(() => {
    const instance = axios.create({
      withCredentials: true,
      baseURL:
        process.env.NODE_ENV === 'development'
          ? '/'
          : isTestUrl()
            ? API.auth.testHost
            : API.auth.host,
    })
    instance
      .post(API.auth.queryUser)
      .then((res) => {
        if (res.status === 200 && res.data.code === 200 && res.data.data.userName) {
          if (!UserAuthorizationService.isLogined()) {
            UserAuthorizationService.setUserName(res.data.data.userName)
            UserAuthorizationService.setUserId(res.data.data.userId)
          }
        } else {
          if (UserAuthorizationService.isLogined()) {
            UserAuthorizationService.removeUserName()
            UserAuthorizationService.removeUserId()
          }
        }
      })
      .catch(console.error)
  }, [])
}
